import nextI18NextConfig from './next-i18next.base.config';

export default {
  ...nextI18NextConfig,
};
